import { fetchGet } from '../utils/fetchRequest'
import { isObjEmpty } from '../utils/common'
import { switchUser } from '../redux/actions/userInfo'
import store from './../redux/store/store'

/**
 * Created by RaoMeng on 2018/11/21
 * Desc: 项目接口
 */

export const _host = 'https://school-api.ydyhz.com'
// export const _host = 'http://qq784602719.imwork.net'
//export const _host = 'http://259p59v947.qicp.vip'

export const _baseURL = _host + '/api/school'
//export const _baseURL = _host

export const API = {
  //获取openId
  GET_OPENID: _baseURL + '/wxPay/getOpenid',
  //3作业发布 4通知公告 5 校长信箱 6会议
  GET_MEETING_LIST: _baseURL + '/notify/getMeetingList',
  //删除附件
  DELETE_FILE: _baseURL + '/picture/deleteFile',
  //视频上传
  INSERT_VIDEO: _baseURL + '/picture/insertVideo',
  //作业 /会议/通知等详情
  TASK_DETAIL: _baseURL + '/notify/taskDetail',
  //发布通知公告/发布作业/创建会议
  ISSUE_NOTIFICATION: _baseURL + '/notify/issueNotification',
  //发布缴费
  PAYMENT_PAYFEE: _baseURL + '/payment/payFee',
  //收费列表家长端
  PAYMENT_PAYMENTLIST: _baseURL + '/payment/paymentList',
  //收费列表教师端
  PAYMENT_PAYMENTLIST_TEACHER: _baseURL + '/payment/paymentListByUserId',
  //收费详情
  PAYMENT_PAYMENT_DETAIL: _baseURL + '/payment/paymentDetails',
  //结束收款
  PAYMENT_ENTPAY: _baseURL + '/payment/endPay',

  //校园卡充值
  RECHARGE_FORCARD: _baseURL + '/payCard/reChangeForCard',
  //校园卡详情
  CARD_DETAIL: _baseURL + '/payCard/cardDetail',
  //校园卡消费记录/充值记录
  CONSUME_RECODE: _baseURL + '/payRank/consumeRecode',
  //获取组织架构
  USER_GETOBJECT: _baseURL + '/user/getObject',

  //修改学生人脸照
  UPDATE_STU_PHOTO: _baseURL + '/wxSchool/user/updateStuPhoto',
  //修改教师人脸照
  UPDATE_TRACHER_PHOTO: _baseURL + '/wxSchool/user/updateTeacherPhoto',

  //根据学号取课程表
  curriculumListByStuId: _baseURL +
    '/wxSchool/clazzCurriculum/curriculumListByStuId',

  //分页显示会议 /分页显示作业 /分页显示通知
  notifyMessage: _baseURL + '/notify/getMeetingList',

  homeWorkList: _baseURL + '/notify/getMeetingList',
  homeWorkDetail: _baseURL + '/notify/taskDetail',

  messageList: _baseURL + '/leaveMessage/getMessageListByNotifyId',

  //发布通知公告/发布作业/创建会议
  issueNotification: _baseURL + '/notify/issueNotification',
  //成绩查询
  getScoreByStuId: _baseURL + '/score/getScoreByStuId',

  //OA单据创建
  oaCreate: _baseURL + '/wxSchool/oaApprove/oaCreate',
  //审批列表
  oaApproveList: _baseURL + '/wxSchool/oaApprove/oaList',
  //审批操作
  doapprove: _baseURL + '/wxSchool/oaApprove/approve',
  //审批单详情
  oaDetails: _baseURL + '/wxSchool/oaApprove/oaDetails',

  //获取分值条件
  getCurr: _baseURL + '/score/getCurr',

  //TODO 接口修改后的
  //创建会议
  createMeeting: _baseURL + '/wxSchool/meeting/createMeeting',
  //会议列表
  meetingList: _baseURL + '/wxSchool/meeting/meetingList',
  //会议详情
  getMeetingDetails: _baseURL + '/wxSchool/meeting/getMeetingDetails',
  //结束会议
  endMeeting: _baseURL + '/wxSchool/meeting/endMeeting',
  //会议签到
  MEETING_SIGN: _baseURL + '/wxSchool/meeting/meetingSign',
  //删除会议
  deleteMeeting: _baseURL + '/wxSchool/meeting/deleteMeeting',
  //通过验证码修改手机号
  updatePhone: _baseURL + '/wxSchool/user/updatePhone',
  //修改学生性别
  updateSex: _baseURL + '/wxSchool/user/updateSex',
  //成绩通知
  getScoreByStu: _baseURL + '/wxSchool/stuScore/getScoreByStu',
  //学生端  学生所在班级的课表  按星期的每天分map
  curriculumListByTeacherId: _baseURL +
    '/wxSchool/clazzCurriculum/curriculumListByTeacherId',
  //创建校长信箱
  PRINCIPAL_MAILBOX: _baseURL + '/wxSchool/principalMailbox/principalMailbox',
  //获取学生和老师所有对象
  getClazzByTeacherId: _baseURL + '/wxSchool/user/getClazzByTeacherId',
  // 获取抄送老师
  getAllTeacher: _baseURL + '/wxSchool/user/getAllTeacher',
  //获取家长
  GET_ALL_PARENT: _baseURL + '/wxSchool/user/getParentsByTeacherId',
  //学生请假
  leaveCreate: _baseURL + '/wxSchool/oaLeave/leaveCreate',
  //维修申请
  brokenCreate: _baseURL + '/wxSchool/property/brokenCreate',
  // 指定维修人员
  repairCreate: _baseURL + '/wxSchool/property/repairCreate',
  //维修完成
  brokenComplete: _baseURL + '/wxSchool/property/brokenComplete',
  //取消维修
  brokenCancel: _baseURL + '/wxSchool/property/brokenCancel',
  //取消维修申请
  brokenDelete: _baseURL + '/wxSchool/property/brokenDelete',
  // 获取物业维修人员
  getRepair: _baseURL + '/wxSchool/property/getRepair',
  // 获取抄送物业人员
  getProperty: _baseURL + '/wxSchool/property/getProperty',
  //家长端请假单列表
  leaveListParent: _baseURL + '/wxSchool/oaLeave/leaveListByStu',
  //教师端请假列表
  leaveListTeacher: _baseURL + '/wxSchool/oaLeave/leaveListByTeacher',
  //学生请假单详情
  leaveDetail: _baseURL + '/wxSchool/oaLeave/lvDetail',
  //请假单回复
  leaveReply: _baseURL + '/wxSchool/oaLeave/lvReply',
  //查询学生出入校记录
  RecordOutgoingList: _baseURL + '/wxSchool/outInRecord/getOutgoingList',
  //创建投票单
  voteCreate: _baseURL + '/wxSchool/vote/voteCreate',//投票创建
  voteListStu: _baseURL + '/wxSchool/vote/voteListStu',//教师端投票单列表
  voteListTeacher: _baseURL + '/wxSchool/vote/voteListForTeacher',//教师端投票单列表

  voteDetailParent: _baseURL + '/wxSchool/vote/voteDetailStu',//家长投票单详情
  voteDetailTeacher: _baseURL + '/wxSchool/vote/voteDetailTeacher',//教师端投票单详情
  voteActionTeacher: _baseURL + '/wxSchool/vote/voteActionTeacher',//老师投票
  voteActionParent: _baseURL + '/wxSchool/vote/voteActionParent',//家长投票

  //分页显示校长信箱（校长端）
  MailboxListTeacher: _baseURL +
    '/wxSchool/principalMailbox/principalMailboxListTeacher',
  //分页显示校长信箱（家长端）
  MailboxListParent: _baseURL +
    '/wxSchool/principalMailbox/principalMailboxListParent',
  //删除校长信箱历史投递
  NOTIFY_DELETEMAIL: _baseURL + '/wxSchool/principalMailbox/deleteMailParent',
  //出入校单次记录详情
  INOUT_RECORD_DETAIL: _baseURL + '/wxSchool/outInRecord/inout/detail',

  //更改手机号时间获取验证码
  SEND_CODEUPDATE: _baseURL + '/wxSchool/user/sendCodeUpdate',

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //获取用户是否绑定
  USER_ISBINDING: _baseURL + '/wxSchool/user/isBinding',
  //获取验证码
  SEND_CODE: _baseURL + '/wxSchool/user/sendCode',
  // //绑定学号
  // BIND_STUDENTID: _baseURL + '/user/bindSt/wxSchool/user/isBindingudentId',
  // //绑定工号
  // BIND_TEACHERID: _baseURL + '/user/bindTeacherId',

  //绑定微信
  BIND_OPENID: _baseURL + '/wxSchool/user/bindOpenid',

  //首页接口
  homeIndex: _baseURL + '/wxSchool/user/homePage',
  //1系统信息 2使用帮助
  SYSTEM_MESSAGE: _baseURL + '/wxSchool/notify/selectNotifyListByType',

  //获取教师班级列表
  GET_CLASS_LIST: _baseURL + '/wxSchool/clazz/selectClazzByTeacher',
  //获取维修单列表
  GET_MY_LIST: _baseURL + '/wxSchool/property/selectMyMaintenance',
  //获取学生班级列表
  GET_STU_CLASS_LIST: _baseURL + '/wxSchool/clazz/selectClazzByStu',
  //文件上传地址
  UPLOAD_FILE: _host + '/api/file/upload',
  //新建相册
  NEW_CLASS_ALBUM: _baseURL + '/wxSchool/clazzAlbum/createAlbum',
  //修改相册
  UPDATE_ALBUM: _baseURL + '/wxSchool/clazzPicture/savePicture',
  //获取班级相册列表
  GET_ALBUM_LIST: _baseURL + '/wxSchool/clazzAlbum/getListPicByClazz',
  //获取相册内所有图片
  GET_PICTURE_LIST: _baseURL + '/wxSchool/clazzPicture/getPictureByAlbum',

  //创建通知公告
  NOTIFY_CREATE: _baseURL + '/notice/savePublish',
  //通知公告列表家长端
  NOTIFY_LIST_PARENT: _baseURL + '/wxSchool/notify/notifyList',
  //通知公告列表教师端
  NOTIFY_LIST_TEACHER: _baseURL + '/wxSchool/notify/notifyList',
  //通知公告详情家长端
  NOTIFY_DETAIL_PARENT: _baseURL + '/wxSchool/notify/getNotify',
  //通知公告详情教师端
  NOTIFY_DETAIL_TEACHER: _baseURL + '/wxSchool/notify/getNotify',
  //教育公告详情
  BUREAU_DETAIL_TEACHER: _baseURL + '/wxSchool/bureau/getBureau',
  //发出的文件管理列表
  FILEMGT_LIST_OUTTEACHER: _baseURL + '/wxSchool/fileMgt/outInFileList',
  //收到的文件管理列表
  FILEMGT_LIST_INTEACHER: _baseURL + '/wxSchool/fileMgt/inInFileList',
  //文件管理详情教师端
  FILEMGT_DETAIL_TEACHER: _baseURL + '/wxSchool/fileMgt/getFileMgt',
  // 获取所有学校
  SCHOOL_LIST: _baseURL + '/wxSchool/school/schoolList',
  // 获取开通信息服务费学校
  SCHOOL_SERVICE_LIST: _baseURL + '/wxSchool/school/schoolServiceCostList',
  // 区域查询
  GET_AREA_LIST: _baseURL + '/wxSchool/area/getAreaList',
  // 获取区域学校
  AREA_SCHOOL_LIST: _baseURL + '/wxSchool/area/areaSchoolList',
  // 电子学生证信息
  ELECTRONIC_CARD_LIST:  _baseURL + '/wxSchool/electronic/electronicCardList',

  GET_ELECTRONIC_CARD:  _baseURL + '/wxSchool/electronic/getElectronicCard',
  // 电子学生证
  ADD_NICKNAME_SIM: _baseURL + '/wxSchool/electronic/addNicknameBySim',
  // 电子学生证学生性别
  ADD_ELECTRONIC_SEX: _baseURL + '/wxSchool/electronic/addSex',

  UPDATE_ELECTRONIC_SHUTDOWN: _baseURL + '/wxSchool/electronic/updateShutdown',
  // 通讯录
  ADD_ELECTRONIC_ADDRESS: _baseURL + '/wxSchool/electronic/saveAddress',
  //电子学生证亲情号码
  ADD_AFFECTION: _baseURL + '/wxSchool/electronic/saveAffection',
  // 电子学亲情号码查询
  AFFECTION_LIST:  _baseURL + '/wxSchool/electronic/affectionList',
  //SOS号码
  GET_SOS_PHONE:  _baseURL + '/wxSchool/electronic/getSosPhone',
  //电子学生证SOS号码
  ADD_SOS_PHONE: _baseURL + '/wxSchool/electronic/saveSosPhone',
  // 新建免打扰时段
  ADD_NO_DISTURBING: _baseURL + '/wxSchool/electronic/saveNoDisturbing',
  // 学生卡解绑
  ELECTRONIC_CARD_RELIEVE: _baseURL + '/wxSchool/electronic/relieve',
  // 电子学生证信息添加
  POST_CARD_SAVE: _baseURL + '/wxSchool/card/save',
  // 电子学生证订购费选项列表
  INFO_CARD_SERVICE_LIST: _baseURL + '/wxSchool/card/getServiceList',
  // 交外部服务费
  ELECTRONIC_CARD_ORDER: _baseURL + '/wxSchool/card/charge/orderCard',
  // 相册项目地址保存
  POST_ALBUM_SAVE: _baseURL + '/wxSchool/album/save',
  // 相册项目相册分类
  INFO_ALBUM_SERVICE_LIST: _baseURL + '/wxSchool/album/getAlbumList',
  // 相册项目订购单
  ELECTRONIC_ALBUM_ORDER: _baseURL + '/wxSchool/album/charge/orderAlbum',
  // 相册订购
  ALBUM_CHARGE_ORDER: _baseURL + '/wxSchool/album/charge/orderPreview',
  // 相册预览
  ALBUM_PICTURE_LIST: _baseURL + '/wxSchool/album/getPreviewList',
  // 获取班级信息
  ALBUM_CLAZZ: _baseURL + '/wxSchool/album/getAlbumClazz',
  // 新生报到写入家长电话
  ALBUM_CLAZZS: _baseURL + '/wxSchool/chechIn/getPhoneItem',
  //获取所有老师手机号
  TEACHER_PHONES_LIST: _baseURL + '/wxSchool/clazz/getAllTeacherBySchool',
  SCHOOL_PHONES_LIST: _baseURL + '/wxSchool/clazz/getSchoolName',
  TEACHER_PHONES_LISTS: _baseURL + '/wxSchool/clazz/getWithBySchool',
  //获取所有维修申请信息
  GET_MAINTENANCE_LIST: _baseURL + '/wxSchool/property/getAllMaintenance',
  //获取相应班级老师电话号码
  GET_TEACHER_PHONES: _baseURL + '/wxSchool/clazz/getTeacherByStuId',
  //获取所教班级家长手机号
  GET_PARENT_PHONES_BYTEACHER: _baseURL +
    '/wxSchool/clazz/selectParentPhoneByTeacher',
  //获取班级家长手机号
  GET_PARENT_PHONES: _baseURL + '/wxSchool/clazz/getParentByClazzId',
  //家长号码列表
  leaveListPhone: _baseURL + '/wxSchool/phone/getPhoneList',
  //电话号码删除
  PARENT_PHONE_DELETE: _baseURL + '/wxSchool/phone/phoneDelete',
  //电话号码创建
  PARENT_PHONE_CREATED: _baseURL + '/wxSchool/phone/phoneCreate',
  // 新生报到家长号码
  PARENT_PHONE_NAME_CREATED: _baseURL + '/wxSchool/phone/phoneNameCreate',
  //获取维修申请明细
  GET_MAINTENANCE_DETAILS: _baseURL +
    '/wxSchool/property/getMaintenanceDetails',
  //学校收费选项列表
  SCHOOL_CHARGE_LIST: _baseURL + '/wxSchool/schoolCharge/getChargeList',
  //学校交费服务
  INFO_SERVICE_CHARGE_ORDER: _baseURL + '/wxSchool/schoolCharge/charge/orderCharge',
  //历史交费记录查询
  INFO_CHARGE_RECORD_LIST: _baseURL + '/wxSchool/schoolCharge/getRecordList',
  //作业列表家长端
  HOMEWORK_LIST_PARENT: _baseURL + '/wxSchool/taskNotify/listTaskStu',
  //作业列表教师端
  HOMEWORK_LIST_TEACHER: _baseURL + '/wxSchool/taskNotify/listTaskTeacher',
  //创建作业发布
  // homeWorkAdd: _baseURL + "/wxSchool/taskNotify/createTask",
  homeWorkAdd: _baseURL + '/homework/savePublish',
  //作业详情
  HOMEWORK_DETAIL: _baseURL + '/wxSchool/taskNotify/taskDetail',
  //作业回复
  HOMEWORK_REPLY: _baseURL + '/wxSchool/taskNotify/taskReply',

  //获取科目列表
  SUBJECT_LIST: _baseURL + '/wxSchool/taskNotify/subjectDOList',

  //身份切换时获取token
  SWITCH_IDENTITY: _baseURL + '/wxSchool/user/switchIdentity',

  //获取学生消费余额接口-GET
  GET_AMOUNTS: _baseURL + '/wxSchool/icCard/amounts',
  //获取学生消费卡状态接口-GET
  GET_CARD_STATE: _baseURL + '/wxSchool/icCard/cardState',

  //生成充值订单并付款-POST
  PAY_ACTION: _baseURL + '/wxSchool/icCard/charge/order',
  //消费列表-GET
  GET_CONSUME_LIST: _baseURL + '/wxSchool/icCard/transaction/page',
  //充值详情-GET
  GET_PAY_DETAIL: _baseURL + '/wxSchool/icCard/charge/order/detail',
  //充值列表-GET
  GET_PAY_LIST: _baseURL + '/wxSchool/icCard/charge/order/page',

  //
  GET_PAY_TEACHER_LIST: _baseURL + '/wxSchool/icCard/teachercharge/order/page',
  //
  PAY_ACTION_TEACHER: _baseURL + '/wxSchool/icCard/teacherCharge/order',
  //
  GET_CONSUME_TEACHER_LIST: _baseURL +
    '/wxSchool/icCard/teacherTransaction/page',
  //
  GET_AMOUNTS_TEACHER: _baseURL + '/wxSchool/icCard/teacherAndAmounts',
  //获取学校班级列表
  GET_SCHOOL_LIST: _baseURL + '/wxSchool/roster/selectClazzBySchool',
  //获取学校班级列表
  GET_SCHOOL_CLASS_LIST: _baseURL + '/wxSchool/roster/selectClazzList',
  //获取学生名单
  GET_ROSTER_LIST: _baseURL + '/wxSchool/roster/getListRoster',
  //获取班级考勤
  GET_CLASS_ROSTER_LIST: _baseURL + '/wxSchool/roster/getClassRoster',
  //学生考勤签到
  STUDENT_SIGNIN: _baseURL + '/wxSchool/roster/updateSignIn',
  //查询学生
  GET_ROSTER_NAME: _baseURL + '/wxSchool/roster/selectStuName',
  //家长绑定学生
  BINDING_STUNAME: _baseURL + '/wxSchool/roster/bindingStu',
  //学生消费卡挂失
  STUDENTS_CARD_LOSE: _baseURL + '/wxSchool/icCard/cardLose',
  //老师消费卡挂失
  TEACHER_CARD_LOSE: _baseURL + '/wxSchool/icCard/teacherCardLose',
  //查询持卡人信息
  SCHOOL_CARD_LIST: _baseURL + '/wxSchool/roster/getCardStu',

  //历史缴费记录查询
  INFO_SERVICE_RECORD_LIST: _baseURL + '/wxSchool/information/getRecordList',
  //信息服务费选项列表
  INFO_SERVICE_SERVICE_LIST: _baseURL + '/wxSchool/information/getServiceList',
  //信息服务费缴费
  INFO_SERVICE_RECHARGE_ORDER: _baseURL +
    '/wxSchool/information/charge/orderInformation',
  //话机话费预存列表
  INFO_CALL_SERVICE_LIST: _baseURL + '/wxPayableCost/callCharge/getPayableList',
  //话费预存缴费
  INFO_CALL_SERVICE_ORDER: _baseURL + '/wxPayableCost/callCharge/charge/orderPayable',
  //话费预存交费记录查询
  INFO_CALL_RECORD_LIST: _baseURL + '/wxPayableCost/callCharge/getCallRecordList',

  //获取已经绑定的身份信息
  VISIT_RECORD_USER_INFO: _baseURL + '/visit/wx/user_info',
  //访客拜访历史记录
  VISIT_RECORD_LIST: _baseURL + '/visit/wx/list',
  //保存拜访申请
  VISIT_RECORD_APPLY: _baseURL + '/visit/wx/apply',
  //读取拜访记录
  VISIT_RECORD_DETAIL: _baseURL + '/visit/wx/read/',
  //审批操作
  VISIT_RECORD_AUDIT: _baseURL + '/visit/wx/approve',
  // 获取抄送老师
  VISIT_RECORD_TEACHER: _baseURL + '/visit/wx/getAllTeacher',
  //
  WRITE_CALLIGRAPHY: _baseURL + '/wxWrite/calligraphy/createTask',
}



